import React from "react";
import { useField, useFormikContext } from "formik";
import { Col, Form, Row } from "react-bootstrap";
import { translate } from "@/hooks/useLanguage";
import { LanguageKey } from "@/types/generated/LanguageKey";
import InputText from "./InputText";

interface FileSelectorProps {
  name?: string;
  filePathName?: string;
  className?: string;
  accept?: string;
  chooseLabel?: string;
  disabled?: boolean;
  onChange?: (data: { file: File; src: string }) => void;
}

const FileSelector: React.FC<FileSelectorProps> = ({
  name,
  filePathName,
  className,
  accept = "",
  chooseLabel = "",
  disabled = false,
  onChange,
}) => {

  const [, meta, helper] = useField(name || "file");

  const { setFieldValue } = useFormikContext();

  let formGroupClass = "";
  if (meta && meta.touched) {
    if (meta.error) {
      formGroupClass = "is-invalid";
    } else {
      formGroupClass = "is-valid";
    }
  }

  const onChangeFile = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const file = event.currentTarget.files?.[0];
    if (file) {
      helper.setValue(file);
      if (filePathName) {
        setFieldValue(filePathName, file.name || "");
      }

      if (onChange) {
        onChange({
          file: file,
          src: file.name,
        });
      }
      event.currentTarget.value = "";
    }
  };

  return (
    <Row>
      {!disabled && (
        <Col className={filePathName ? "col-lg-4 col-12" : "col-12"}>
          <Form.Label
            className={`${
              className ? className : ""
            } btn btn-sensolus-greylight`}
          >
            <Form.Control
              type="file"
              accept={accept}
              disabled={disabled}
              style={{ display: "none" }}
              onChange={onChangeFile}
            />
            {chooseLabel || translate(LanguageKey.choose_file_key)}
          </Form.Label>
        </Col>
      )}

      {filePathName && (
        <Col xs="12" lg="8">
          <InputText name={filePathName} disabled={true} />
        </Col>
      )}

      <Col
        xs="12"
        className={`${formGroupClass} ${
          formGroupClass === "is-invalid" ? "d-block" : "d-none"
        }`}
      >
        <Form.Control.Feedback type="invalid">
          {meta.error}
        </Form.Control.Feedback>
      </Col>
    </Row>
  );
};

export default FileSelector;